import { motion } from 'framer-motion';
import React from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '../ui/button';
import LandingPrompt from './LandingPrompt';
import GitHubCTA from './GitHubCTA';
import HeroBackground from '../ui/HeroBackground';

const HeroSection: React.FC = () => {
  return (
    <HeroBackground>
      <div className="min-h-[calc(100vh-4rem)] flex items-center">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
          <div className="max-w-3xl mx-auto text-center">
            {/* Hero Section Content */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="space-y-8"
            >
              <a
                href="https://www.ycombinator.com/companies/structured-labs"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs text-muted-foreground border border-gray-200 rounded-full px-2 py-2 bg-white/80 backdrop-blur-sm hover:bg-gray-50 transition-colors"
              >
                <img
                  src="/yc.png"
                  alt="Y Combinator"
                  className="h-4 ml-1 mr-1 w-auto filter opacity-90"
                />
                <span>Backed by Y Combinator</span>
              </a>
              <div className="space-y-6">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900">
                From idea to app, instantly.
                </h1>
                <p className="text-xl text-gray-600">
                Preswald is your AI-native dev environment for data apps. Turn Python scripts into interactive dashboards, reports, and tools you can share or deploy instantly.</p>
              </div>
              <div className="space-y-4">
                <LandingPrompt />
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button
                    size="lg"
                    className="w-full sm:w-auto px-4"
                    asChild
                  >
                    <Link to="/sign-up">
                      Get Started Free
                    </Link>
                  </Button>
                  <GitHubCTA />
                </div>
                <p className="text-sm text-gray-500">
                  No credit card required. Start building in seconds.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </HeroBackground>
  );
};

export default HeroSection; 